import { jwtDecode } from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

interface DecodedToken {
  exp: number;
  [key: string]: any; // Optional additional fields
}

@Injectable({
  providedIn: 'root'
})
export class AuthUtilsService {
  constructor(private cookieService: CookieService,
    private storageService: StorageService) { }

  checkAndSetUserFromToken() {
    const token = this.cookieService.get('auth_token');

    if (!token) {
      return;
    }

    try {
      const decoded: any = jwtDecode<DecodedToken>(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decoded.exp < currentTime) {
        this.cookieService.delete('auth_token');
        return;
      }
      const userData = {
        name: decoded.name,
        email: decoded.email,
        token: token
      };

      this.storageService.setUser(userData);

    } catch (error) {
      console.error('Invalid token:', error);
      this.cookieService.delete('auth_token');
    }
  }
}
